import React, { FC, useCallback } from 'react';
import { OperatorProps } from '../../../../@types/TemplateOperators';
import { ArgsInput, ArgsSelect } from './BasicComponents';

import { getColumnDropDownOptions, validateColumnInitValue } from './utils';

const Default: FC<OperatorProps> = ({ step, handleArgsChange, dropDownOptions }) => {
  const [columnNumber, defaultValue] = step.args;

  const options = getColumnDropDownOptions(dropDownOptions);
  const columnInitialValue = validateColumnInitValue(columnNumber, options.length);

  const defaultInputHandler = useCallback(
    (value: string) => {
      handleArgsChange([columnNumber, value]);
    },
    [columnNumber, handleArgsChange]
  );

  const columnValueHandler = useCallback(
    (value: number | string): void => {
      handleArgsChange([value, defaultValue]);
    },
    [handleArgsChange, defaultValue]
  );

  return (
    <>
      <div className="flex mt-6 w-1/2" data-testid="default-operator">
        <ArgsSelect
          argsSelectLabel="column"
          options={options}
          onChange={columnValueHandler}
          value={columnInitialValue}
          label="Column number from the input file"
        />
      </div>
      <div className="flex mt-6 w-1/2">
        <ArgsInput
          placeholder="default"
          initialValue={defaultValue || ''}
          onChange={defaultInputHandler}
          label="default"
          subLabel="Value to use when Column is empty"
        />
      </div>
    </>
  );
};

export default Default;
